import { useCallback, useEffect } from 'react';

export function useKeyDown(callback: (key: string) => void, keys: string[]) {
    const keyDown = useCallback((event: KeyboardEvent): void => {
        if (keys.some(key => event.key === key)) {
            event.preventDefault();

            callback(event.key);
        }
    }, [callback, keys]);

    useEffect(() => {
        document.addEventListener('keydown', keyDown);

        return () => document.removeEventListener('keydown', keyDown);
    }, [keyDown]);
}

export function useKeyUp(callback: (key: string) => void, keys: string[]) {
    const keyUp = useCallback((event: KeyboardEvent): void => {
        if (keys.some(key => event.key === key)) {
            event.preventDefault();

            callback(event.key);
        }
    }, [callback, keys]);

    useEffect(() => {
        document.addEventListener('keyup', keyUp);

        return () => document.removeEventListener('keyup', keyUp);
    }, [keyUp]);
}